import getPrivilege from "utils/privileges/privileges"
import { Button } from "components/common"
import { useRef } from "react"
import InvoiceModal from "../../../invoiceModal"

const InvoiceId = ({ data, privileges }) => {
  const invoiceRef = useRef()
  return (
    <div>
      {getPrivilege(["can_access_billing_module"], privileges) ? (
        <Button
          className={"p-0"}
          type="link"
          text={data}
          onClick={() => {
            invoiceRef?.current?.showFor(data)
          }}
        />
      ) : (
        <div>{data}</div>
      )}
      <InvoiceModal ref={invoiceRef} />
    </div>
  )
}

export default InvoiceId
